import WS from './Socket'
// const url = window.location.href
// const suffix = url.split('.')[url.split('.').length - 1]
// const host = (suffix === 'com') ? (`ws.${process.env.WS_HOST || 'accumulatorclub.com'}`) : (`ws.${process.env.WS_HOST || 'accumulatorclub.co.uk'}`)
const host = `${process.env.WS_HOST || 'fantasyprod.gamingenius.net'}`
const config = /*(process.env.NODE_ENV === 'development') ? {host: '127.0.0.1', port:9090, wss:false} :*/ {host, wss: true}
const socketopts =  config /*{host, wss: true}*/
let Socket = new WS(socketopts)
Socket.onOpen = () => console.log('open')
Socket.onError = () => console.log('Error!')
Socket.onClose = () => Socket.terminate()
export default Socket


// WEBPACK FOOTER //
// ./src/Socket/socket-init.ts